import React from "react";
import {
    CheckSquareOutlined,
    VideoCameraFilled,
    FacebookFilled,
    InstagramFilled,
    YoutubeFilled,
    PictureFilled,
} from "@ant-design/icons";
import { Button, ConfigProvider, Space } from "antd";
import useStyle from "../../hooks/useStyle";
import style from "./LinksPage.module.scss";

export default function LinksPage() {
    const { styles } = useStyle();

    return (
        <ConfigProvider>
            <Space className={style.root}>
                <Button
                    className={styles.linearGradientButton}
                    type="primary"
                    size="large"
                    icon={<CheckSquareOutlined />}
                    href="/#/vote"
                    target="_blank"
                >
                    Голосування
                </Button>
                <Button
                    type="default"
                    className={styles.linearGradientButton2}
                    size="large"
                    icon={<VideoCameraFilled />}
                    href="/program_2025_.pdf"
                    target="_blank"
                >
                    Програма
                </Button>

                <Button
                    type="default"
                    className={styles.linearGradientButton2}
                    size="large"
                    icon={<PictureFilled />}
                    href="https://drive.google.com/drive/folders/1imIkup-GNYkWLySwesIAcYgDgNsMdwEN"
                    target="_blank"
                >
                    Фотогалерея
                </Button>

                <Button
                    type="default"
                    className={styles.linearGradientButton2}
                    size="large"
                    icon={<InstagramFilled />}
                    href="https://www.instagram.com/svitlofilmfestival"
                    target="_blank"
                >
                    Instagram
                </Button>
                <Button
                    type="default"
                    className={styles.linearGradientButton2}
                    size="large"
                    icon={<FacebookFilled />}
                    href="https://www.facebook.com/svitlofilmfestival"
                    target="_blank"
                >
                    Facebook
                </Button>
                <Button
                    type="default"
                    className={styles.linearGradientButton2}
                    size="large"
                    icon={<YoutubeFilled />}
                    href="https://www.youtube.com/@svitlofilmfestival"
                    target="_blank"
                >
                    YouTube
                </Button>
            </Space>
        </ConfigProvider>
    );
}
